/* eslint-disable */
import axios, {Axios} from 'axios'
import {hideDialog, isnull, localClear, localGet, localGetBoolean, reLogin, showDialog, Toast} from '../utils/tools'
import globalCfg from '../config/global'
import global from "../config/global";
import Qs from 'querystring'
import {ResultCode} from "../utils/TipsUtils";
import {reloginInBg} from "../api/home-api";
import {Queue} from "../utils/SetUtils";
import NetHepler from "./nethelper";

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 4 * 30 * 1000    // 请求超时时间
export const ERR_OK = true      // 请求成功返回状态，字段和后台统一
// 引入全局url，定义在全局变量process.env中，开发环境为了方便转发，值为空字符串
// axios.defaults.baseURL = '/webApp'

// 请求超时时间
axios.defaults.timeout = TIME_OUT

var pageTarget = null

let whiteUrl = [
  'api/Account/Login',
  'api/Account/TryPlay',
  'api/Account/Register',
  'api/web_download'
]
let fileBase = 'https://pd.halolive.online/'

function reqToken() {
  return new Date().getTime() + '' + Math.round(Math.random() * 1000) + '' + global.channelId + '' + global.clientVersion.replace(/\./g, '');
}


// 封装请求拦截
axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')   // 获取token
    if (isnull(config.headers['Content-Type']) || config.headers['Content-Type'].indexOf('multipart/form-data') == -1)
      config.headers['Content-Type'] = 'application/json;charset=UTF-8'
    config.headers['Authorization'] = ''
    if (token != null) {                          // 如果token不为null，否则传token给后台
      config.headers['Authorization'] = token
    }
    config.headers['X-Request-ID'] = reqToken()
    return config
  },
  error => {
    return Promise.reject(error)
  }
)
// 封装响应拦截，判断token是否过期
// axios.interceptors.response.use(
//   response => {
//     let {data} = response
//     if ([-84, -85,-85].indexOf(data.retCode) != -1) {
//       // 如果后台返回的错误标识为token过期，则重新登录
//       // localStorage.removeItem('token')          // token过期，移除token
//       // 进行重新登录操作
//       reLogin(pageTarget)
//
//     } else {
//       return Promise.resolve(response)
//     }
//   },
//   error => {
//     return Promise.reject(error)
//   }
// )

function dealRequest(reqUrl) {
  if (!reqUrl.startsWith('http') && !reqUrl.startsWith('https')) {
    reqUrl = baseUrl + '/' + reqUrl
  }
  return reqUrl
}

// 封装post请求
export function fetch(requestUrl, params = '') {

  return axios({
    url: requestUrl,
    method: 'post',
    data: {
      'body': params
    }
  })
}

function illegalSession() {
  // window.history.go(-(window.history.length - 1))
  // localClear()
}

export async function get(requestUrl, params = [], successCallback = null, failCallBack = null, prefix = '/webApp', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    Toast.error('No network', vueObj)
    hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }
  if (!localGetBoolean(global.LOGIN_STATUS, false) && whiteUrl.indexOf(requestUrl) == -1) {
    if (!relogined) {
      NetHepler.relogin(vueObj, () => {
        setTimeout(function () {
          get(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true)
        }, 3000)
      }, (code, msg, page) => {
        failCallBack && failCallBack(code, msg, page)
      })

      return
    }
    failCallBack && failCallBack(-1, '', '')
    return
  }
  pageTarget = vueObj
  let paramsUrl = ''
  if (!isnull(params)) {
    params = checkSession(params)
    paramsUrl += '?' + params.join('&')
  }
  setBase(prefix)
  if (showLoading)
    showDialog(vueObj)
  let axiosCfg = {
    baseURL: prefix,
    url: requestUrl + paramsUrl,
    method: 'get',
  };
  if (!isnull(headers))
    axiosCfg.headers = headers
  return axios(axiosCfg).then(res => {
    if (hideLoading)
      hideDialog(vueObj)
    let {data} = res
    if (data.retCode == 0 || data.code == 0) {
      successCallback && successCallback(data.data)
    } else {
      if (data.retCode == -83 || data.retCode == -84 || data.retCode == -85) {
        illegalSession()
        if (!relogined) {
          NetHepler.relogin(vueObj, () => {
            setTimeout(function () {
              get(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true)
            }, 3000)
          }, (code, msg, page) => {
            failCallBack && failCallBack(code, msg, page)
          })
          return
        }

      }
      failCallBack && failCallBack(data.retCode, data.msg, data)
    }

  }).catch(error => {
    // if (hideLoading)
    hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')
    console.log(error)
  })

}

export async function postQ(requestUrl, params = [], successCallback = null, failCallBack = null, prefix = '/webApp', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    Toast.error('No network', vueObj)
    hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }
  if (!localGetBoolean(global.LOGIN_STATUS, false) && whiteUrl.indexOf(requestUrl) == -1) {
    if (!relogined) {
      NetHepler.relogin(vueObj, () => {
        setTimeout(function () {
          postQ(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true)
        }, 3000)
      }, (code, msg, page) => {
        failCallBack && failCallBack(code, msg, page)
      })
      return
    }
    failCallBack && failCallBack(-1, '', '')
    return
  }
  pageTarget = vueObj
  let paramsUrl = ''
  if (!isnull(params)) {
    params = checkSession(params)
    paramsUrl += '?' + params.join('&')
  }
  setBase(prefix)
  if (showLoading)
    showDialog(vueObj)
  let axiosCfg = {
    baseURL: prefix,
    url: requestUrl + paramsUrl,
    method: 'post',
  };
  if (!isnull(headers))
    axiosCfg.headers = headers
  return axios(axiosCfg).then(res => {
    if (hideLoading)
      hideDialog(vueObj)
    let {data} = res
    if (data.retCode == 0 || data.code == 0) {
      successCallback && successCallback(data.data)
    } else {
      if (data.retCode == -83 || data.retCode == -84 || data.retCode == -85) {
        illegalSession()
        if (!relogined) {
          NetHepler.relogin(vueObj, () => {
            setTimeout(function () {
              postQ(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true)
            }, 3000)
          }, (code, msg, page) => {
            failCallBack && failCallBack(code, msg, page)
          })

          return
        }

      }
      failCallBack && failCallBack(data.retCode, data.msg, data)
    }

  }).catch(error => {
    // if (hideLoading)
    hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')
    console.log(error)
  })
}

function setBase(base) {
  axios.defaults.baseURL = base
}

function checkSession(params) {
  if (!isnull(params)) {
    params.forEach((item, index) => {
      if (item.indexOf('session=') != -1) {
        params[index] = 'session=' + global.getSession()
      }
    })
    return params
  }

}

export async function postB(requestUrl, params = {}, successCallback = null, failCallBack = null, prefix = '/webApp', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    Toast.error('No network', vueObj)
    hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }
  if (!localGetBoolean(global.LOGIN_STATUS, false) && whiteUrl.indexOf(requestUrl) == -1) {
    if (!relogined) {
      NetHepler.relogin(vueObj, () => {
        setTimeout(function () {
          postB(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true);
        }, 3000)
      }, (code, msg, page) => {
        failCallBack && failCallBack(code, msg, page)
      })
      return
    }
    failCallBack && failCallBack(-1, '', '')
    return
  }
  pageTarget = vueObj
  setBase(prefix)

  if (showLoading)
    showDialog(vueObj)
  let axiosCfg = {
    baseUrl: prefix,
    url: requestUrl,
    method: 'post',
    data: params
  };
  if (!isnull(headers))
    axiosCfg.headers = headers
  return axios(axiosCfg).then(res => {
    if (hideLoading)
      hideDialog(vueObj)
    let {data} = res
    if (data.retCode == 0 || data.code == 0) {
      successCallback && successCallback(data.data)
    } else {
      if (data.retCode == -83 || data.retCode == -84 || data.retCode == -85) {
        illegalSession()
        if (!relogined) {
          NetHepler.relogin(vueObj, () => {
            setTimeout(function () {
              postB(requestUrl, params, successCallback, failCallBack, prefix, vueObj, false, false, headers, true);
            }, 3000)
          }, (code, msg, page) => {
            failCallBack && failCallBack(code, msg, page)
          })
          return
        }
      }
      failCallBack && failCallBack(data.retCode, data.message, data)
    }

  }).catch(error => {
    // if (hideLoading)
    hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')
    console.log(error)
  })
}

export async function postQB(requestUrl, qparams = {}, bparams = {}, successCallback = null, failCallBack = null, prefix = '/webApp', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    Toast.error('No network', vueObj)
    hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }
  if (!localGetBoolean(global.LOGIN_STATUS, false) && whiteUrl.indexOf(requestUrl) == -1) {
    if (!relogined) {
      NetHepler.relogin(vueObj, () => {
        setTimeout(function () {
          let session = localGet(globalCfg.key.session);
          if (isnull(session))
            return
          postQB(requestUrl, qparams, bparams, successCallback, failCallBack, prefix, vueObj, false, false, headers, true);
        }, 3000)
      }, (code, msg, page) => {
        failCallBack && failCallBack(code, msg, page)
      })
      return
    }
    failCallBack && failCallBack(-1, '', '')
    return
  }
  pageTarget = vueObj
  let paramsUrl = ''
  if (!isnull(qparams)) {
    qparams = checkSession(qparams)
    paramsUrl += '?' + qparams.join('&')
  }
  setBase(prefix)
  if (showLoading)
    showDialog(vueObj)
  let axiosCfg = {
    baseUrl: prefix,
    url: requestUrl + paramsUrl,
    method: 'post',
    data: bparams
  };
  if (!isnull(headers))
    axiosCfg.headers = headers
  return axios(axiosCfg).then(res => {
    if (hideLoading)
      hideDialog(vueObj)
    let {data} = res
    if (data.retCode == 0 || data.code == 0) {
      successCallback && successCallback(data.data)
    } else {
      if (data.retCode == -83 || data.retCode == -84 || data.retCode == -85) {
        illegalSession()
        if (!relogined) {
          NetHepler.relogin(vueObj, () => {
            setTimeout(function () {
              let session = localGet(globalCfg.key.session);
              if (isnull(session))
                return
              postQB(requestUrl, qparams, bparams, successCallback, failCallBack, prefix, vueObj, false, false, headers, true);
            }, 3000)
          }, (code, msg, page) => {
            failCallBack && failCallBack(code, msg, page)
          })
          return
        }
      }
      failCallBack && failCallBack(data.retCode, data.message, data)
    }

  }).catch(error => {
    // if (hideLoading)
    hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')
    console.log(error)
  })
}


export async function uploadFile(requestUrl, params = {}, successCallback = null, failCallBack = null, prefix = '/s3file', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    if (!isnull(vueObj))
      hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }

  pageTarget = vueObj

  setBase(prefix)
  if (showLoading && !isnull(vueObj))
    showDialog(vueObj)

  if (isnull(headers))
    headers = {}
  headers['Content-Type'] = 'multipart/form-data'

  let axiosCfg = {
    url: fileBase + requestUrl,
    method: 'post',
    data: params,
    headers: headers
  };

  return axios(axiosCfg).then(res => {
    if (hideLoading && !isnull(vueObj))
      hideDialog(vueObj)
    let {data} = res
    if (data.retCode == 0 || data.code == 0) {
      successCallback && successCallback(data.data)
    } else {
      failCallBack && failCallBack(data.retCode, data.message, data)
    }

  }).catch(error => {
    if (!isnull(vueObj))
      hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')

  })
}

export async function classifyImg(requestUrl, params = [], successCallback = null, failCallBack = null, prefix = '/webApp', vueObj = '', showLoading = true, hideLoading = true, headers = null, relogined = false) {
  if (isnull(vueObj))
    vueObj = global.getApplication()
  if (isnull(vueObj) || !vueObj.$root.online) {
    Toast.error('No network', vueObj)
    hideDialog(vueObj)
    failCallBack && failCallBack(ResultCode.NO_NETWORK, '', '')
    return
  }

  let paramsUrl = ''
  if (!isnull(params)) {
    paramsUrl += '?' + params.join('&')
  }
  if (showLoading)
    showDialog(vueObj)
  let axiosCfg = {
    url: fileBase + requestUrl + paramsUrl,
    method: 'get',
  };
  if (!isnull(headers))
    axiosCfg.headers = headers
  return axios(axiosCfg).then(res => {
    if (hideLoading)
      hideDialog(vueObj)
    let {data} = res
    successCallback && successCallback(data)

  }).catch(error => {
    // if (hideLoading)
    hideDialog(vueObj)
    // failCallBack && failCallBack(-1, 'Unkown error')
    console.log(error)
  })

}



// WEBPACK FOOTER //
// ./src/apiconfig/index.js